export function canSwitchMode(mode) {
    return true;
}
//# sourceMappingURL=view-mode.js.map


//////////////////
// WEBPACK FOOTER
// C:/Users/strahinja.aparac/Desktop/git/source/healthcare/v2/app/appointment-widget/node_modules/ngx-bootstrap/datepicker/engine/view-mode.js
// module id = ../../../../ngx-bootstrap/datepicker/engine/view-mode.js
// module chunks = vendor